module.exports = __webpack_public_path__ + "static/media/11_saltaire-white_rock.21c9f331.jpg";